import { FileRenderType } from "./types";

const hideLeftMenu = () => {
  const leftMenu = document.querySelector(".ant-layout-sider.leftMenu");
  if (leftMenu) {
    leftMenu.setAttribute("style", "display: none !important");
  }
};

const showLeftMenu = () => {
  const leftMenu = document.querySelector(".ant-layout-sider.leftMenu");
  if (leftMenu) {
    (leftMenu as HTMLElement).style.removeProperty("display");
  }
};

const excelExtensions = ["xls", "xlsx", "xlsm", "xlsb"];
const wordExtensions = ["doc", "docx", "dot"];
const officeExtensions = [...excelExtensions, ...wordExtensions];

const getRenderType = (fileName: string): FileRenderType => {
  const extension = fileName.split(".").pop()?.toLowerCase();
  if (!extension) return;
  if (officeExtensions.includes(extension)) {
    return "officeOnlineLInk";
  }

  if (extension === "pdf") {
    return "pdfOnlineLink";
  }

  return;
};

export { showLeftMenu, hideLeftMenu, getRenderType, excelExtensions, wordExtensions };
